import React, { Component } from "react";
import { makeStyles } from '@material-ui/core/styles';
import { applyDataTable } from '../../../custom/dataTable';
import View from '../../../../assets/img/svg/view.svg';
import Edit from '../../../../assets/img/svg/edit.svg';
import Delete from '../../../../assets/img/svg/delete.svg';
import FilterIcon from '../../../../assets/img/svg/FilterIcon.svg'
import del from "../../../../assets/img/svg/Del.svg"
import download from "../../../../assets/img/svg/DownloadIcon.svg"
import Autocomplete from "react-autocomplete"
import { useNavigate } from "react-router-dom";
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Pagination from "../../../custom/Pagination";
import $ from "jquery";
import {
    TextField, FormControlLabel, Radio, Checkbox,
    Select, MenuItem, InputBase, Chip, Input, Button, InputAdornment,
    IconButton, FormHelperText, FormControl, RadioGroup
} from '@material-ui/core';
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from "../../../../assets/jss/customStyle";
import { withStyles } from '@material-ui/core/styles';
import axios from "axios";
import API from "../../../../_helpers/endpointService";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import moment from "moment";
import { getDIS_ListView, deletemultiDIS } from "../../../../actions/DispositionAction";
import { getlookupdocinfo } from "../../../../actions/MasterDataAction";
import { LaptopWindows } from "@material-ui/icons";
import { getSettingsFormat } from "../../../../actions/SettingsAction";

const useStyles = makeStyles((theme) => ({
    button: {
        background: "#FFFFFF",
        border: "none",
        boxSizing: "border-box",
        borderRadius: "7px",
    },
    fontIcon: {
        paddingRight: "8px",
    }
}));

class ListViewDROHM extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile: false,
            totalMT: true,
            ProjectId: 0,
            Delete: [],
            DIS_ListView: [],
            hide: 0,
            isAccess: false,
            searchData: {
                ProjectId: 0,
                Material: '',
                FromDate: '',
                ToDate: '',
                PageNumber: 1,
                PageSize: 100
            }
        }
    }
    componentDidMount() {
        const { dispatch } = this.props;
        this.state.ProjectId = localStorage.getItem("DashId");
        this.state.searchData.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.setState({})
        if (this.state.UserRole === "Admin" || this.state.UserRole == "Supervisor") {
            this.setState({ isAccess: true })
        }
        else{
            this.setState({ isAccess: false })
        }
        this.props.dispatch(getSettingsFormat(this.state.ProjectId))
        dispatch(getlookupdocinfo("Hazardous"))
        this.dataTable(this.state.searchData, this.state.ProjectId);
        window.addEventListener("resize", this.resize.bind(this));
        this.resize()
        this.interval = setInterval(() => {
            this.resize1()
        }, 10);
    }
    componentWillUnmount() {
        clearInterval(this.interval);
        window.removeEventListener("resize", this.resize.bind(this));
        $("#DIS1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Disposition1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Disposition").addClass("d-none");
        $("#Disposition").removeClass("d-block");
        $("#DROHML").removeClass("active-color");
        $("#DROHMT").removeClass("fw-bolder");
    }
    dataTable = (data, id) => {
        let apiUrl = API.DIS_LISTVIEW + '?projectId=' + id + '&Material=' + data.Material + '&FromDate=' + data.FromDate + '&ToDate=' + data.ToDate + '&PageNumber=' + data.PageNumber + '&PageSize=' + data.PageSize;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.dispatch({ type: "DIS_LISTVIEW", data: response.data });
                    this.setState({
                        DIS_ListView: response.data
                    }, () => { applyDataTable("staffTable") })
                }
                else {

                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {

                }
            });
    };
    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }

        // this.state.DIS_ListView = this.props.DIS_ListView;
        // this.setState({})

    };
    resize1 = () => {
        $("#DIS1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Disposition1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Disposition").removeClass("d-none");
        $("#Disposition").addClass("d-block");
        $("#DROHML").addClass("active-color");
        $("#DROHMT").addClass("fw-bolder");
    }
    sidebar = () => {
        this.props.navigate("/sidebar");
    }
    AddNew = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        this.props.navigate("/dispositionrecordsofhazardousmaterials/addnew")
    };

    EditPage = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        this.props.navigate("/dispositionrecordsofhazardousmaterials/edit")
    };

    ViewPage = () => {
        this.props.navigate("/dispositionrecordsofhazardousmaterials/view")
    };
    handleCheckboxChange = (e, x) => {
        const { Delete } = this.state;
        if (Delete.length == 0) {
            Delete.push(x)
        }
        else {
            if (Delete.filter((i) => i == x).length == 1) {
                Delete.map((i, ind) => (
                    i == x ?
                        Delete.splice(ind, 1)
                        : ""
                ))
            } else {
                Delete.push(x)
            }
        }
        this.setState({})
        if (Delete.length == 1) {
            localStorage.setItem("DISEditId", Delete[0])
        }

        this.state.hide = Delete.length;
        this.setState({})


    };
    DeleteItem = () => {
        let tempData = [];
        const { Delete } = this.state;
        window.$("#deletepopup").modal("hide");
        this.deletemultiDIS(Delete, this.state.ProjectId, this.state.UserRole)
        this.state.hide = 0;
        this.setState({});
        $('input[type=checkbox]').prop('checked', false);
    }
    deletemultiDIS = (data, id, modify) => {
        let ids = "";
        if (data && data.length > 0) {
            data.map((val, index) => {
                if (index == 0) {
                    ids += "ids=" + val;
                }
                else {
                    ids += "&ids=" + val;
                }
            })
        }
      
        let apiUrl = API.DIS_LISTVIEW + '/ids?' + ids + '&modify=' + modify;

        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "delete",
            url: apiUrl,

        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.state.Delete = [];
                    this.setState({});
                    this.dataTable(this.state.searchData, this.state.ProjectId);
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {

                }
            });

    };
    handleChange = (e) => {
        this.state.totalMT = this.state.totalMT;
        this.setState({})
    }
    handleInputChange = (e, node) => {
        this.state.searchData[node] = e.target.value;
        this.setState({});
    };
    handleProjectNameSearchChange = (e) => {
        this.state.searchData.Material = e.target.value;
        this.setState({});
    };
    renderProjectNames = (state, val) => {
        return state?.Name?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
    };
    handleProjectNameSelectChange = (e) => {
        this.state.searchData.Material = e;
        this.setState({});
    };
    Search = () => {
        const { dispatch } = this.props;
        this.dataTable(this.state.searchData, this.state.ProjectId);
        // dispatch(getDIS_ListView(this.state.searchData, this.state.ProjectId))
    }
    ResetFilter() {
        const { dispatch } = this.props;
        const input = {
            Material: '',
            FromDate: '',
            ToDate: '',
            PageNumber: 1,
            PageSize: 100,
        };
        this.state.searchData = input;
        this.setState({});
        // this.dataTable(this.state.searchData, this.state.ProjectId);
    }
    BackPage = () => {
        this.state.searchData.PageNumber = this.state.searchData.PageNumber - 1;
        this.setState({})
        this.props.dispatch(getDIS_ListView(this.state.searchData, this.state.ProjectId))
    }

    NextPage = () => {
        this.state.searchData.PageNumber = this.state.searchData.PageNumber + 1;
        this.setState({})
        this.props.dispatch(getDIS_ListView(this.state.searchData, this.state.ProjectId))
    }
    render() {

        let { classes, menuToggle } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100  mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-4 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"DIS" + "1"} className=' textNaviIcon' style={{ fontSize: '13px' }} primary="Daily Tasks" />
                                            <NavigateNextIcon id="DIS" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-3 mt-5">
                                    <h4>Disposition Records of Hazardous Materials</h4>
                                </div>
                            </div>


                        </>

                        :
                        <></>
                }
                <div className={this.state.isMobile ?"ml-auto scroll-hide mb-5 border-top":"ml-auto scroll-hide mb-5"} style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                {this.state.isAccess?<>
                    {this.state.isMobile ? <table className="dataTable " width="100%">
                        <tbody>
                            <tr>
                                <td className="border-right text-center">
                                    <button className={classes.button} disabled={this.state.isAccess === true ? this.state.hide == 1 ? false : true : true} onClick={this.EditPage} style={{ minWidth: '70px' }}><img src={Edit} style={{ marginTop: '-4px', opacity: this.state.isAccess === true ? this.state.hide == 1 ? '' : '0.5' : '0.5' }}></img>&nbsp;Edit</button>
                                </td>
                                <td className="border-right text-center">
                                    <button className={`${classes.button}`} disabled={this.state.isAccess === true ? this.state.hide > 0 ? false : true : true} data-target="#deletepopup" data-toggle="modal" style={{ minWidth: '70px' }}><img src={Delete} style={{ marginTop: '-4px', opacity: this.state.isAccess === true ? this.state.hide > 0 ? '' : '0.5' : '0.5' }}></img>&nbsp;Delete</button>
                                </td>
                                <td className="text-center" style={{ whiteSpace: 'nowrap' }}>
                                    <button className={`${classes.button} px-0`} disabled={this.state.isAccess === true ? false : true} onClick={this.AddNew} style={{ minWidth: '70px' }}><i className="fa fa-plus pr-2" style={{ color: "#00838F", opacity: this.state.isAccess == true ? '' : '0.5' }}></i>Add New</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                        :
                        <>
                            <div className="row  border-bottom">
                                <div className="col-xl-3  col-md-3 col-lg-3 col-sm-3   d-flex">
                                    <button className={`${classes.button} pl-3`} disabled={this.state.isAccess === true ? this.state.hide == 1 ? false : true : true} onClick={this.EditPage} style={{ minWidth: '70px' }}><img src={Edit} style={{ marginTop: '-4px', opacity: this.state.isAccess === true ? this.state.hide == 1 ? '' : '0.5' : '0.5' }}></img>&nbsp;Edit</button>
                                    <button className={`${classes.button}`} disabled={this.state.isAccess === true ? this.state.hide > 0 ? false : true : true} data-target="#deletepopup" data-toggle="modal" style={{ minWidth: '70px' }}><img src={Delete} style={{ marginTop: '-4px', opacity: this.state.isAccess === true ? this.state.hide > 0 ? '' : '0.5' : '0.5' }}></img>&nbsp;Delete</button>
                                    <div className="col-xl-12 p-3 col-md-12 col-lg-12 col-sm-12  ml-2 border-left">
                                        <button className={classes.button} disabled={this.state.isAccess === true ? false : true} onClick={this.AddNew} style={{ minWidth: '70px' }}><i className="fa fa-plus pr-2" style={{ color: "#00838F", opacity: this.state.isAccess == true ? '' : '0.5' }}></i>Add New</button>
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                    </>:<></>}
                    <div className="row" style={{ margin: this.state.isMobile ? "" : "5px" }}>
                        <div className="row px-3">
                            <div className="col-10 pt-2">
                                {this.state.isMobile ? <></> : <h6>Disposition Records of Hazardous Materials</h6>}
                            </div>
                            <div className="col-2 pt-2">
                                <button data-toggle="modal" data-target="#custom-modal" className={`${classes.button} float-end`} style={{ minWidth: '70px' }}><img src={FilterIcon} />&nbsp;Filter </button>
                            </div>
                        </div>
                        <div className={this.state.isMobile ? "col-12 px-4 pt-2 mt-1" : "col-12 px-3 pt-2 mt-1"}>
                            <div className="table-responsive mb-5" style={{ width: "100%" }}>
                                <table id="staffTable" className="table table-hover product_table">
                                    <thead>
                                        <tr className="">
                                            {this.state.isAccess ? 
                                            <th width="3%" className="border-left"><span className="spandoc-thead" style={{ color: "#000000" }}></span></th>
                                            :<></>}
                                            <th width="8%" className="border-right align-middle border-left" style={{ minWidth: '65px' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Date</span></th>
                                            <th width="8%" className="border-right align-middle"><span className="spandoc-thead" style={{ color: "#000000" }}>Material</span></th>
                                            <th width="8%" className="border-right align-middle"><span className="spandoc-thead" style={{ color: "#000000" }}>Manifest No</span></th>
                                            <th width="8%" className="border-right align-middle"><span className="spandoc-thead" style={{ color: "#000000" }}>Attachment</span></th>
                                            <th width="8%" className="border-right align-middle"><span className="spandoc-thead" style={{ color: "#000000" }}>Quantity As Per IHM</span></th>
                                            <th width="8%" className="border-right align-middle"><span className="spandoc-thead" style={{ color: "#000000" }}>Quantity By GPCB (MT)</span></th>
                                            <th width="" className="border-right align-middle" style={{ minWidth: window.innerWidth < 1000 ? '200px' : '' }}> <span className="spandoc-thead" style={{ color: "#000000" }}>Remarks</span></th>
                                            <th width="5%" className="border-right align-middle"><span className="spandoc-thead" style={{ color: "#000000" }}>Quantity (MT) Disposed</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.DIS_ListView?.Disposition && this.state.DIS_ListView?.Disposition.map((i, v) => (
                                            <>
                                                {i.Values && i.Values.map((ind) => (
                                                    <tr>
                                                        {this.state.isAccess ? 
                                                        <td className="spandoc-td align-middle border-left"><input type="checkbox" style={{ height: '16px', width: '16px' }} onChange={(e) => this.handleCheckboxChange(e, ind.Id)} /></td>
                                                        :<></>}
                                                        <td className="spandoc-td border-right align-middle border-left">{ind.Date && moment(ind.Date).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}</td>
                                                        <td className="spandoc-td border-right align-middle">{ind.Material}</td>
                                                        <td className="spandoc-td border-right align-middle">{ind.ManifestNo}</td>
                                                        <td className="spandoc-td border-right align-middle"><a className="cursorPointer" href={ind?.Attachment?.FileUrl} target="_blank">{ind.Attachment?.FileName}</a></td>
                                                        <td className="spandoc-td border-right align-middle text-right">{ind.QuantityIHM}</td>
                                                        <td className="spandoc-td border-right align-middle text-right">{ind.QuantityGPCB}</td>
                                                        <td className="spandoc-td border-right align-middle ">{ind.Remarks}</td>
                                                        <td className="spandoc-td border-right align-middle text-right">{ind.DiposedMTQuantity}</td>
                                                    </tr>
                                                ))}
                                                <tr>
                                                    <td className="spandoc-td border-left border-right" colSpan={this.state.isAccess? 7: 6}></td>
                                                    <td className="spanTopBar">Total</td>
                                                    <td className="border-left spanTopBar border-right text-right">{i.Total}</td>
                                                </tr>
                                            </>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="modal left fade pt-5 mt-3" id="custom-modal" tabIndex={-1} role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" style={{ width: this.state.isMobile ? "250px" : "" }}>
                            <div className="modal-content border-radius">
                                <div className="modal-header">
                                    <div className="row m-0">
                                        <h6 className="modal-title" id="myCenterModalLabel">Advanced Filter</h6>
                                        <div className="col-12">
                                            <span className="cursorPointer" onClick={() => this.ResetFilter()}>
                                                <img src={FilterIcon} />&nbsp;<span>Reset to default</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-body p-4">
                                    <form id="myform">
                                        <div className="form-group row">
                                            <div className="col-5 m-auto">
                                                <label htmlFor="name">Date - From</label></div>
                                            <div className="col-7">
                                                <input
                                                    type="date"
                                                    id="type-date1"
                                                    value={this.state.searchData.FromDate && moment(this.state.searchData.FromDate).format("yyyy-MM-DD")}
                                                    placeholder={this.state.searchData.FromDate && moment(this.state.searchData.FromDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                    onChange={(e) => { this.handleInputChange(e, "FromDate") }}
                                                    style={{ fontSize: 12, height: "38px" }}
                                                    className='form-control border-radius'
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    max={JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}
                                                    min={JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-5 m-auto">
                                                <label htmlFor="name">Date - To</label></div>
                                            <div className="col-7">
                                                <input
                                                    type="date"
                                                    id="type-date1"
                                                    value={this.state.searchData.ToDate && moment(this.state.searchData.ToDate).format("yyyy-MM-DD")}
                                                    max={JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}
                                                    min={JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}
                                                    placeholder={this.state.searchData.ToDate && moment(this.state.searchData.ToDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                    onChange={(e) => { this.handleInputChange(e, "ToDate") }}
                                                    style={{ fontSize: 12, height: "38px" }}
                                                    className='form-control border-radius'
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-5 m-auto">
                                                <label htmlFor="name">Material</label></div>
                                            <div className="col-7">
                                                <div className=" autocomplete-wrappers">
                                                    <Autocomplete
                                                        contentEditable={true}
                                                        value={this.state.searchData.Material}
                                                        inputProps={{
                                                            placeholder: "Material",
                                                        }}

                                                        items={this.props.DIS_Material ?? []}
                                                        getItemValue={(item) => item.Name}
                                                        shouldItemRender={this.renderProjectNames.bind(this)}
                                                        renderMenu={(item) => (
                                                            <div className="dropdowns d-block" >{item}</div>
                                                        )}

                                                        renderInput={(props) => {
                                                            return (
                                                                <input
                                                                    className="form-control border-radius"
                                                                    id="exampleFormControlInput1"
                                                                    {...props}
                                                                    style={{ width: '100%', height: 35, fontSize: 12, color: "#000000" }}
                                                                />
                                                            );
                                                        }}
                                                        renderItem={(item, isHighlighted) => (
                                                            <div
                                                                className={`items 
                         ${isHighlighted ? "selected-items" : ""
                                                                    }`}
                                                            >
                                                                {item.Name}
                                                            </div>
                                                        )}
                                                        onChange={(e) => this.handleProjectNameSearchChange(e)}
                                                        onSelect={(e) => this.handleProjectNameSelectChange(e)}
                                                    />

                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className="row text-center mt-4">
                                            <div className="col-2"></div>
                                            <div className="col-5" data-dismiss="modal">
                                                <button type="button" className="btn input-group border-radius f-size-13 filter-btn" style={{ backgroundColor: "#00838F", color: "#FFFFFF" }} onClick={() => this.Search()}>Search</button>
                                            </div>
                                            <div className="col-5" data-dismiss="modal">
                                                <button type="button" id="closemodal" className="btn btn-light input-group border-radius f-size-13 filter-btn">Cancel</button>
                                            </div>
                                        </div> */}
                                        <div className="row text-center mt-4">
                                            {this.state.isMobile ? <></> : <div className="col-2"></div>}
                                            <div className={this.state.isMobile ? "col-6" : "col-5"} data-dismiss="modal">
                                                <button type="button" className={`btn btn-primary input-group border-radius f-size-13 ${this.state.isMobile ? " filter-Mobilebtn" : "filter-btn"}`} data-toggle="modal" style={{ backgroundColor: "#00838F", color: "#FFFFFF" }} onClick={() => this.Search()}>Search</button>
                                            </div>
                                            <div className={this.state.isMobile ? "col-6" : "col-5"} data-dismiss="modal">
                                                <button type="button" id="closemodal" className={`btn btn-light input-group border-radius f-size-13 ${this.state.isMobile ? " filter-Mobilebtn" : "filter-btn"}`}>Cancel</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div >
                    <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>

                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.DeleteItem}><span className="" >Delete</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className={`${classes.pagination}`}>
                    <div className={`${classes.paginationItem}`}>
                        {this.state.searchData.PageNumber == 1 ? <></> :
                            <ArrowBackIcon className={classes.arrow} onClick={() => this.BackPage()} />}
                        <span className="pl-2 pr-2">Page {this.state.searchData.PageNumber}</span>
                        {(this.state.searchData.PageNumber == this.state.DIS_ListView?.pagination?.PageCount) || (this.state.DIS_ListView?.pagination?.PageCount == 0) ? <></> :
                            <ArrowForwardIcon className={classes.arrow} onClick={() => this.NextPage()} />}
                    </div>
                </div> */}
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        DIS_ListView: state.DispositionReducer.DIS_ListView || [],
        DIS_Material: state.MasterDataReducer.Lookup_data || [],
        settings: state.commonReducer.settings || [],

    };
}

ListViewDROHM.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ListViewDROHM))
);
